import { UsersThree, Briefcase, Coins, ShieldCheck, GraduationCap, Compass, Truck, Storefront, Bank, FirstAid, Factory, Package, Buildings, ShoppingCart } from "@phosphor-icons/react";

export const SERVICES = [
  { key: "staffing", icon: UsersThree, title: "Staffing & Manpower Solutions",
    desc: "Blue-collar and frontline workforce hiring for warehouses, retail, logistics, e-commerce, manufacturing and other operational businesses." },
  { key: "recruitment", icon: Briefcase, title: "Recruitment Solutions",
    desc: "End-to-end recruitment for entry-level, mid-level and senior positions across multiple industries." },
  { key: "payroll", icon: Coins, title: "Payroll Management",
    desc: "Complete payroll processing, attendance management, salary processing, employee documentation and workforce administration." },
  { key: "compliance", icon: ShieldCheck, title: "HR & Statutory Compliance",
    desc: "Support for PF, ESIC, Professional Tax, employee documentation and statutory compliance processes." },
  { key: "whitecollar", icon: GraduationCap, title: "White Collar Recruitment",
    desc: "Specialised recruitment for executives, managers, HR, finance, sales, operations, technology and leadership positions." },
  { key: "consulting", icon: Compass, title: "Workforce & HR Consulting",
    desc: "Practical HR solutions to help businesses improve workforce planning, recruitment, processes and employee management." },
];

export const INDUSTRIES = [
  { name: "E-Commerce", icon: ShoppingCart },
  { name: "Logistics & Supply Chain", icon: Truck },
  { name: "Retail", icon: Storefront },
  { name: "BFSI", icon: Bank },
  { name: "Healthcare", icon: FirstAid },
  { name: "Manufacturing", icon: Factory },
  { name: "Warehousing", icon: Package },
  { name: "Corporate & Professional Services", icon: Buildings },
];

export const WHY = [
  { title: "Faster Hiring", desc: "Build candidate pipelines and support rapid workforce deployment." },
  { title: "Dedicated Recruitment Team", desc: "Experienced recruiters supporting multiple hiring requirements." },
  { title: "End-to-End Workforce Management", desc: "From sourcing and onboarding to payroll and compliance support." },
  { title: "Industry Understanding", desc: "Experience across retail, logistics, e-commerce, BFSI, healthcare and other sectors." },
  { title: "Scalable Solutions", desc: "Support businesses ranging from individual hiring requirements to large workforce deployments." },
  { title: "Single HR Partner", desc: "One partner for recruitment, staffing, payroll and workforce-related requirements." },
];

export const PROCESS = [
  { step: "01", title: "Understand", desc: "Deep-dive into role, culture and business needs." },
  { step: "02", title: "Source", desc: "Tap curated pipelines, referrals and databases." },
  { step: "03", title: "Screen", desc: "Skills, background and cultural fit checks." },
  { step: "04", title: "Deploy", desc: "Onboarding, documentation and go-live support." },
  { step: "05", title: "Manage", desc: "Payroll, attendance and workforce administration." },
  { step: "06", title: "Support", desc: "Ongoing compliance and relationship management." },
];
